import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
export default {
	name: 'stocktransfer',
	components: {
		Paginate,
		DatePicker,
		VueElementLoading
	},
	data: function() {
		return {
			resultCount: 0,
			pageno: 0,
			pagecount: 0,

			hubList: [],
			hubStatusModal: false,
			changestatus: '',
			useremail: '',
			status: '',
			isLoading: false,
			selectedHubId: '',

		}
	},

	created: function() {},
	computed: {},

	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.warehouseid = userdetail[0].warehouseid;
		this.useremail = userdetail[0].email;
		this.pageno = 0;
		this.getHubMappedListData();

	},
	methods: {

		changeHubStatus() {
			this.isLoading = true;
			if (this.changestatus == 'De-Activate') {
				var newStatus = false;
			} else {
				var newStatus = true;
			}
			this.input = ({
				groupId: this.$route.params.grouptemplateId,
				destinationhubId: this.selectedHubId,
				isActive: newStatus,
			})
			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'deAllocateGroupMapByHubId',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;
					if (result.data.ResultCode == 500) {
						this.$alertify.error(result.data.ReturnMessage)
					}
					if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage)
					}
					if (result.data.ResultCode == 100) {
						this.$alertify.success('Hub Status Changed Successfully')
					}
					this.groupStatusModal = false;
					this.getHubMappedListData();
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		//to close edit form
		closeStatusHubModal() {
			this.hubStatusModal = false
		},

		//to close add (new) form
		closeviewRTOmodal() {
			this.viewRTOmodal = false
		},
		getStatusRowData(data) {
			//console.log(data);
			this.hubStatusModal = true;
			this.selectedHubId = data.destinationhubid;
			this.status = data.isactive;

			if (data.isactive == true) {
				this.changestatus = 'De-Activate'
			} else {
				this.changestatus = 'Activate'
			}
		},
		getHubMappedListData() {
			this.isLoading = true;
			this.input = ({})
			axios({
					method: 'GET',
					// legacy backup: fetchGroupsAllocatedDestinationByGroupId
					// 'url': apiUrl.api_url_hubops + 'fetchGroupsAllocatedDestinationByGroupId?groupId=' + this.$route.params.grouptemplateId,
					'url': apiUrl.api_url_hubops + 'groups?groupId=' + this.$route.params.grouptemplateId + '&include=templateDestinations&responseShape=destinationsOnly',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.ResultCode == 500) {
						this.$alertify.error(result.data.ReturnMessage)
					}
					if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage);
						this.resultCount = 0;
						this.hubList = [];
					}
					if (result.data.ResultCode == 100) {
						this.hubList = result.data.ResponseData
						let totalRows = result.data.ResponseData.length
						this.resultCount = result.data.ResponseData.length
						if (totalRows < 10) {
							this.pagecount = 1
						} else {
							this.pagecount = Math.ceil(totalRows / 10)
						}
					}

				}, error => {
					console.error(error)
				})
		},

		//to get pagination
		getPaginationData(pageNum) {
			this.pageno = (pageNum - 1) * 10
			this.getHubMappedListData()
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid')
			}).catch(() => {
				console.log('errors exist')
			});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/group/groupWiseHubs/groupWiseHubs.component.js